import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0323 = React.lazy(() => import('./symbols/0323_computer_desktop'));
const Symbol0324 = React.lazy(() => import('./symbols/0324_computer_screen'));
const Symbol0325 = React.lazy(() => import('./symbols/0325_computer_screen_cloud'));
const Symbol0326 = React.lazy(() => import('./symbols/0326_computer_screen_users_profile'));
const Symbol0327 = React.lazy(() => import('./symbols/0327_computer_screen_settings_preferences'));
const Symbol0328 = React.lazy(
  () => import('./symbols/0328_computer_screen_locked_password_protected_security')
);
const Symbol0329 = React.lazy(() => import('./symbols/0329_computer_laptop_user_login'));
const Symbol0330 = React.lazy(() => import('./symbols/0330_computer_laptop_download'));
const Symbol0331 = React.lazy(() => import('./symbols/0331_computer_laptop_analytics_graph'));
const Symbol0332 = React.lazy(() => import('./symbols/0332_computer_laptop_website_url_www'));
const Symbol0333 = React.lazy(() => import('./symbols/0333_printer'));
const Symbol0334 = React.lazy(() => import('./symbols/0334_shredder_paper'));
const Symbol0335 = React.lazy(() => import('./symbols/0335_cd_dvd_disc_software'));
const Symbol0336 = React.lazy(() => import('./symbols/0336_disc_floppy_save_software'));
const Symbol0337 = React.lazy(() => import('./symbols/0337_keyboard_connect'));
const Symbol0338 = React.lazy(() => import('./symbols/0338_keyboard_wired'));
const Symbol0339 = React.lazy(() => import('./symbols/0339_keyboard_wireless'));
const Symbol0340 = React.lazy(() => import('./symbols/0340_mouse'));
const Symbol0341 = React.lazy(() => import('./symbols/0341_mouse_wireless'));
const Symbol0342 = React.lazy(() => import('./symbols/0342_remote_control'));
const Symbol0343 = React.lazy(() => import('./symbols/0343_ipad_tablet'));
const Symbol0344 = React.lazy(() => import('./symbols/0344_iphone_mobile'));
const Symbol0345 = React.lazy(() => import('./symbols/0345_chip_cpu_64_bit_processor'));
const Symbol0346 = React.lazy(() => import('./symbols/0346_magnet'));
const Symbol0347 = React.lazy(() => import('./symbols/0347_usb'));
const Symbol0348 = React.lazy(() => import('./symbols/0348_thunderbolt'));
const Symbol0349 = React.lazy(() => import('./symbols/0349_usb_connect'));
const Symbol0350 = React.lazy(() => import('./symbols/0350_apple_connect'));
const Symbol0351 = React.lazy(() => import('./symbols/0351_apple_lightning_connect'));
const Symbol0352 = React.lazy(() => import('./symbols/0352_apple_lightning_connect'));

export interface IProps {}

const Technology: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0323_computer_desktop" symbol={<Symbol0323 />} />
      <LazySymbol id="0324_computer_screen" symbol={<Symbol0324 />} />
      <LazySymbol id="0325_computer_screen_cloud" symbol={<Symbol0325 />} />
      <LazySymbol id="0326_computer_screen_users_profile" symbol={<Symbol0326 />} />
      <LazySymbol id="0327_computer_screen_settings_preferences" symbol={<Symbol0327 />} />
      <LazySymbol
        id="0328_computer_screen_locked_password_protected_security"
        symbol={<Symbol0328 />}
      />
      <LazySymbol id="0329_computer_laptop_user_login" symbol={<Symbol0329 />} />
      <LazySymbol id="0330_computer_laptop_download" symbol={<Symbol0330 />} />
      <LazySymbol id="0331_computer_laptop_analytics_graph" symbol={<Symbol0331 />} />
      <LazySymbol id="0332_computer_laptop_website_url_www" symbol={<Symbol0332 />} />
      <LazySymbol id="0333_printer" symbol={<Symbol0333 />} />
      <LazySymbol id="0334_shredder_paper" symbol={<Symbol0334 />} />
      <LazySymbol id="0335_cd_dvd_disc_software" symbol={<Symbol0335 />} />
      <LazySymbol id="0336_disc_floppy_save_software" symbol={<Symbol0336 />} />
      <LazySymbol id="0337_keyboard_connect" symbol={<Symbol0337 />} />
      <LazySymbol id="0338_keyboard_wired" symbol={<Symbol0338 />} />
      <LazySymbol id="0339_keyboard_wireless" symbol={<Symbol0339 />} />
      <LazySymbol id="0340_mouse" symbol={<Symbol0340 />} />
      <LazySymbol id="0341_mouse_wireless" symbol={<Symbol0341 />} />
      <LazySymbol id="0342_remote_control" symbol={<Symbol0342 />} />
      <LazySymbol id="0343_ipad_tablet" symbol={<Symbol0343 />} />
      <LazySymbol id="0344_iphone_mobile" symbol={<Symbol0344 />} />
      <LazySymbol id="0345_chip_cpu_64_bit_processor" symbol={<Symbol0345 />} />
      <LazySymbol id="0346_magnet" symbol={<Symbol0346 />} />
      <LazySymbol id="0347_usb" symbol={<Symbol0347 />} />
      <LazySymbol id="0348_thunderbolt" symbol={<Symbol0348 />} />
      <LazySymbol id="0349_usb_connect" symbol={<Symbol0349 />} />
      <LazySymbol id="0350_apple_connect" symbol={<Symbol0350 />} />
      <LazySymbol id="0351_apple_lightning_connect" symbol={<Symbol0351 />} />
      <LazySymbol id="0352_apple_lightning_connect" symbol={<Symbol0352 />} />
    </>
  );
});

export default Technology;
